/**
 * Grundbuchmeldung API
 * API for Grundbuchmeldung Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GemeindeListEntry } from './gemeindeListEntry';
import { MeldungsEmpfaengerId } from './meldungsEmpfaengerId';


export interface MeldungsEmpfaengerDetailEntry { 
    meldungsEmpfaengerId?: MeldungsEmpfaengerId;
    modificationCounter?: number;
    bezeichnung?: string;
    sedexId?: string;
    erhaeltMeldungen?: boolean;
    erhaeltVertraulicheDaten?: boolean;
    erhaeltBasedelivery?: boolean;
    hasMeldungen?: boolean;
    registriertAufEreignisse?: Array<MeldungsEmpfaengerDetailEntry.RegistriertAufEreignisseEnum>;
    eingeschraenktAufGemeinden?: Array<GemeindeListEntry>;
}
export namespace MeldungsEmpfaengerDetailEntry {
    export type RegistriertAufEreignisseEnum = 'NEU_LIG_SDR' | 'LOESCHUNG_LIG_SDR' | 'AENDERUNG_LIG_SDR' | 'NEU_STW_MIT' | 'LOESCHUNG_STW_MIT' | 'AENDERUNG_STW_MIT' | 'NEU_EIGENTUM' | 'LOESCHUNG_EIGENTUM' | 'AENDERUNG_EIGENTUM' | 'NEU_ANMERKUNG' | 'LOESCHUNG_ANMERKUNG' | 'AENDERUNG_ANMERKUNG' | 'NEU_DIENSTBARKEIT' | 'LOESCHUNG_DIENSTBARKEIT' | 'AENDERUNG_DIENSTBARKEIT' | 'NEU_GRUNDLAST' | 'LOESCHUNG_GRUNDLAST' | 'AENDERUNG_GRUNDLAST' | 'NEU_VORMERKUNG' | 'LOESCHUNG_VORMERKUNG' | 'AENDERUNG_VORMERKUNG' | 'NEU_PFANDRECHT' | 'LOESCHUNG_PFANDRECHT' | 'AENDERUNG_PFANDRECHT';
    export const RegistriertAufEreignisseEnum = {
        NEULIGSDR: 'NEU_LIG_SDR' as RegistriertAufEreignisseEnum,
        LOESCHUNGLIGSDR: 'LOESCHUNG_LIG_SDR' as RegistriertAufEreignisseEnum,
        AENDERUNGLIGSDR: 'AENDERUNG_LIG_SDR' as RegistriertAufEreignisseEnum,
        NEUSTWMIT: 'NEU_STW_MIT' as RegistriertAufEreignisseEnum,
        LOESCHUNGSTWMIT: 'LOESCHUNG_STW_MIT' as RegistriertAufEreignisseEnum,
        AENDERUNGSTWMIT: 'AENDERUNG_STW_MIT' as RegistriertAufEreignisseEnum,
        NEUEIGENTUM: 'NEU_EIGENTUM' as RegistriertAufEreignisseEnum,
        LOESCHUNGEIGENTUM: 'LOESCHUNG_EIGENTUM' as RegistriertAufEreignisseEnum,
        AENDERUNGEIGENTUM: 'AENDERUNG_EIGENTUM' as RegistriertAufEreignisseEnum,
        NEUANMERKUNG: 'NEU_ANMERKUNG' as RegistriertAufEreignisseEnum,
        LOESCHUNGANMERKUNG: 'LOESCHUNG_ANMERKUNG' as RegistriertAufEreignisseEnum,
        AENDERUNGANMERKUNG: 'AENDERUNG_ANMERKUNG' as RegistriertAufEreignisseEnum,
        NEUDIENSTBARKEIT: 'NEU_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        LOESCHUNGDIENSTBARKEIT: 'LOESCHUNG_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        AENDERUNGDIENSTBARKEIT: 'AENDERUNG_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        NEUGRUNDLAST: 'NEU_GRUNDLAST' as RegistriertAufEreignisseEnum,
        LOESCHUNGGRUNDLAST: 'LOESCHUNG_GRUNDLAST' as RegistriertAufEreignisseEnum,
        AENDERUNGGRUNDLAST: 'AENDERUNG_GRUNDLAST' as RegistriertAufEreignisseEnum,
        NEUVORMERKUNG: 'NEU_VORMERKUNG' as RegistriertAufEreignisseEnum,
        LOESCHUNGVORMERKUNG: 'LOESCHUNG_VORMERKUNG' as RegistriertAufEreignisseEnum,
        AENDERUNGVORMERKUNG: 'AENDERUNG_VORMERKUNG' as RegistriertAufEreignisseEnum,
        NEUPFANDRECHT: 'NEU_PFANDRECHT' as RegistriertAufEreignisseEnum,
        LOESCHUNGPFANDRECHT: 'LOESCHUNG_PFANDRECHT' as RegistriertAufEreignisseEnum,
        AENDERUNGPFANDRECHT: 'AENDERUNG_PFANDRECHT' as RegistriertAufEreignisseEnum
    };
}


